import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { AdvtService } from '../../_services/advt.service';
import { AlertService } from '../../_services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Location } from '@angular/common';



@Component({
  selector: 'app-service-payment-request',
  templateUrl: './service-payment-request.component.html',
  styleUrls: ['./service-payment-request.component.css']
})
export class ServicePaymentRequestComponent implements OnInit {
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild('template2') template2: TemplateRef<any>;

  modalRef: BsModalRef;
  currentUser;
  buyer_id;
  sub: Subscription;
  item_id;
  seller_id;

  payment_req1: Boolean = true;
  payment_req2: Boolean = false;
  payment_req3: Boolean = false;

  payment1;
  payment2;
  payment3;

  amount;
  ItemData;
  PaymentRequestData: Array<any> = [];

  Payment_Icon1;
  Payment_Icon2;
  Payment_Icon3;
  totalamount;
  warning;
  requestallowed;
  NullAmount: Boolean = false;
  mainLoader;
  loading: Boolean = false;
  amountPending;
  pending_amount;
  payment_type;
  userId: string;
  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout: 5000
  }


  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private _location: Location
  ) { }

  ngOnInit() {
    //  if (localStorage.getItem('currentMenu')) {
    //   localStorage.removeItem('currentMenu');
    //   localStorage.setItem('currentMenu', 'home');
    // }
    window.scrollTo(0, 0);
    const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    this.userId = userInfo.result.id;
    this.currentUser = userInfo ? userInfo.result : null;
    this.seller_id = userInfo.result ? userInfo.result.id : null;

    this.sub = this.route.params.subscribe((params) => {
      this.item_id = params['itemId'];
    });
    this.getItem();
    this.warning = '../../assets/images/warning.png';
    this.mainLoader = '../../assets/images/BigLoader.gif';


    setTimeout(() => {
      this.PaymentRequestBySeller();
    }, 1000);


  }

  /**
   * get Item detail by item id
   */
  getItem() {
    this.loading = true;
    this.advtService.getItemDetail(this.item_id).subscribe(data => {
      this.ItemData = data;
      this.buyer_id = data.buyer_id;
      this.totalamount = data.bidAmount;
    })
    this.loading = false;

  }

  /**
   * function to check the payment done or not
   */
  PaymentRequestBySeller() {
    this.loading = true;
    let params = {
      seller_id: this.seller_id,
      item_id: this.item_id
    }
    this.advtService.CheckPaymentRequest(params).subscribe(data => {
      if (data.status == 200) {
        this.requestallowed = data.requestAllowed;
        this.PaymentRequestData = data.result;
        if (this.PaymentRequestData == null) {
          this.payment_req1 = true;
          this.payment_req2 = false;
          this.payment_req3 = false;
        } else {
          if (data.result && data.result[0].amount) {
            this.payment1 = data.result[0].amount;
            this.payment_req1 = false;
            this.payment_req2 = true;
            this.payment_req3 = false;
            this.Payment_Icon1 = '../../assets/images/tick.svg';

          } if (data.result[1] && data.result[1].amount) {
            this.payment2 = data.result[1].amount;
            this.payment_req1 = false;
            this.payment_req2 = false;
            this.payment_req3 = false;
            if (this.requestallowed == true) {
              this.payment3 = data.result[1].amount_pending;
            }
            this.Payment_Icon1 = '../../assets/images/tick.svg';
            this.Payment_Icon2 = '../../assets/images/tick.svg';
          } if (data.result[2] && data.result[2].amount) {
            this.payment2 = data.result[1].amount;
            this.payment_req1 = false;
            this.payment_req2 = false;
            this.payment_req3 = false;

            this.payment3 = data.result[1].amount_pending;
            this.Payment_Icon1 = '../../assets/images/tick.svg';
            this.Payment_Icon2 = '../../assets/images/tick.svg';
          } if (data.result[2] && data.result[2].amount) {
            this.payment3 = data.result[2].amount;

            this.payment_req1 = false;
            this.payment_req2 = false;
            this.payment_req3 = false;

            this.Payment_Icon1 = '../../assets/images/tick.svg';
            this.Payment_Icon2 = '../../assets/images/tick.svg';
            this.Payment_Icon3 = '../../assets/images/tick.svg';
          }
          let last: any = this.PaymentRequestData[this.PaymentRequestData.length - 1];
          this.amountPending = last.amount_pending;
          this.pending_amount = last.amount_pending;
          this.payment_type = last.part_payment;
        }
      }
    })
    this.loading = false;
  }
  /**
   * Function to send payment request to buyer
   */
  paymentRequest() {
    this.loading = true;

    if (this.requestallowed == false) {
      this.alertService.warning('Alert!  Please Wait for previous payment to complete');
    }
    if (this.payment1 == null && this.payment2 == null && this.payment3 == null) {
      this.alertService.warning('Alert!  Please Enter the amount');
    } if (this.requestallowed == true) {
      if (this.payment1 == null && this.payment2 == null && this.payment3 == null) {
        this.alertService.warning('Alert! Please Enter the amount');
      } if (this.payment1 == null) {
        this.alertService.warning('Alert! Please Enter the amount');
      }
      if (this.pending_amount == 0 && this.payment_type == 3) {
        this.alertService.success(' All payments received successfully !');
      } else {
        if (this.payment1 != null) {
          this.amount = this.payment1;
        } if (this.payment2 != null) {
          this.amount = this.payment2;
        } if (this.payment3 != null) {
          this.amount = this.payment3;
        }

        let params = {
          seller_id: this.seller_id,
          buyer_id: this.buyer_id,
          item_id: this.item_id,
          amount: this.amount,
        }
        this.advtService.PaymentRequest(params).subscribe(data => {
          if (data.status == 200) {
            this.PaymentRequestBySeller();
            this.alertService.success("Payment request sent Successfully!");
          } if (data.status == 400) {
            this.alertService.warning(data.message);
          }
        })
      }


    }
    this.loading = false;
  }

  /**
 * function to check payment1 
 * @param event input value of payment1
 */
  paymentCheck(event: any) {
    this.requestallowed = true;
    if (this.ItemData.bidAmount <= parseInt(this.payment1)) {
      this.requestallowed = false;
      this.openModal(this.template);
      return false;
    }

    // if (parseFloat(this.payment1) < 1) {
    //   event.preventDefault();
    //   this.alertService.warning('Minimum Requested Amount should be greater than $1');
    //   this.requestallowed = false;
    //   return false;

    // }
  }

  /**
   * function to check payment2
   * @param event input value of payment2
   */
  paymentCheck2(event: any) {
    this.requestallowed = true;
    let last: any = this.PaymentRequestData[this.PaymentRequestData.length - 1];
    let amount_pending = last.amount_pending;
    if (amount_pending <= parseInt(this.payment2)) {
      this.requestallowed = false;
      event.preventDefault();
      this.openModal(this.template);
      return false;
    }
    /*if (parseFloat(this.payment2) < 1) {
      event.preventDefault();
      this.alertService.warning('Minimum Requested Amount should be greater than $1');
      this.requestallowed = false;
      return false;
    }*/

  }

  /**
  * function to check payment2
  * @param event input value of payment2
  */
  paymentCheck3(event: any) {
    this.requestallowed = true;
    let last: any = this.PaymentRequestData[this.PaymentRequestData.length - 1];
    let amount_pending = last.amount_pending;
    // this.pending_amount = last.amount_pending;
    // this.payment_type = last.part_payment;
    if (amount_pending < parseFloat(this.payment3)) {
      this.requestallowed = false;
      event.preventDefault();
      this.openModal(this.template);
    }
    /*if (amount_pending > parseFloat(this.payment3)) {
      this.requestallowed = false;
      event.preventDefault();
      this.openModal(this.template2);
    }*/
  }

  _checkNumPattern(event: any) {
    const pattern = /[0-9\+\.\ ]/;
    if (event.which === 32 && event.target.selectionStart === 0) {
      return false;
    } if (event.which === 48 && event.target.selectionStart === 0) {
      return false;
    } let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  /**
   * 
   *function to open model 
   */
  public openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-md' })
    );
  }



  backClicked() {
    this._location.back();
  }




}



// WEBPACK FOOTER //
// ./src/app/authorized-data/service-payment-request/service-payment-request.component.ts